export default __webpack_public_path__ + "media/onboarding/welcome_transfers-c6a98569.png";